<template>
  <v-data-table
    :headers="headers"
    :items="outcomes"
    :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS"
    :items-per-page-text="CONST.ROWS_PER_PAGE_TEXT">
    <template #[`item.loadingDate`]="{ item }">
      {{ formatLocalDate(getRawItem(item).loadingDate) }}
    </template>
    <template #[`item.destiny.name`]="{ item }">
      {{ getRawItem(item).destiny?.name || '' }}
    </template>
    <template #[`item.receiver.name`]="{ item }">
      {{ getRawItem(item).receiver?.name || '' }}
    </template>
    <template #[`item.packagingType.packagingType`]="{ item }">
      {{ getRawItem(item).packagingType?.packagingType || '' }}
    </template>
    <template #[`item.netWeight`]="{ item }">
      {{ getNetWeight(getRawItem(item)) }}
    </template>
    <template #[`item.carrier.name`]="{ item }">
      {{ getRawItem(item).carrier?.name || '' }}
    </template>
    <template #[`item.actions`]="{ item }">
      <div class="action-cell">
        <v-btn v-if="canUpdate" icon size="small" variant="text" class="table-action-button" aria-label="Editar" @click="editItem(getRawItem(item))">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn icon size="small" variant="text" class="table-action-button" aria-label="Ver mercaderia" @click="showCommodity(getRawItem(item))">
          <v-icon>inventory_2</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-slot:no-data>
      <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
      <v-btn color="primary" @click="initialize">{{ CONST.REFRESH }}</v-btn>
    </template>
  </v-data-table>

  <v-dialog v-model="commodityDialog" max-width="900">
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <span>Mercaderia de la salida {{ selectedOutcomeNumber }}</span>
        <v-btn icon="close" variant="text" aria-label="Cerrar" title="Cerrar" @click="commodityDialog = false"></v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="commodityHeaders"
          :items="selectedCommodities"
          :items-per-page="5"
          :items-per-page-options="[5, 10]"
          items-per-page-text="Filas por pagina">
          <template #[`item.qualityType.qualityType`]='{ item }'>
            {{ getRawItem(item).qualityType?.qualityType || '' }}
          </template>
          <template #[`item.packagingType.packagingType`]='{ item }'>
            {{ getRawItem(item).packagingType?.packagingType || '' }}
          </template>
          <template #no-data>
            <span>La salida no tiene mercaderia asociada.</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { formatLocalDate as formatDate, toLocalDateInput } from '../../services/common/UtilsFunctions'
import { mapGetters } from 'vuex'
export default {
  name: 'OutcomeTable',
  data: () => ({
    CONST: {},
    headers: [
      {title: 'Nro. Salida', align: 'center', key: 'outcomeNumber'},
      {title: 'Fecha', align: 'center', key: 'loadingDate'},
      {title: 'Destino', align: 'center', key: 'destiny.name', sortable: false},
      {title: 'Destinatario', align: 'center', key: 'receiver.name', sortable: false},
      {title: 'Bolsas', align: 'center', key: 'bagQuantity', sortable: false},
      {title: 'Empaque', align: 'center', key: 'packagingType.packagingType', sortable: false},
      {title: 'Peso neto', align: 'center', key: 'netWeight', sortable: false},
      {title: 'Transporte', align: 'center', key: 'carrier.name', sortable: false},
      {title: 'Acciones', align: 'center', key: 'actions', sortable: false}
    ],
    outcomes: [],
    commodityDialog: false,
    selectedOutcomeNumber: '',
    selectedCommodities: [],
    commodityHeaders: [
      { title: 'Ubicacion', key: 'locationInPlant' },
      { title: 'Calidad', key: 'qualityType.qualityType' },
      { title: 'Empaque', key: 'packagingType.packagingType' },
      { title: 'Bultos', key: 'bagQuantity' },
      { title: 'Kilogramos', key: 'amount' },
      { title: 'Gramaje', key: 'gramaje' }
    ]
  }),

  computed: {
    ...mapGetters(['isRefreshTableRequired']),
    ...mapGetters('outcomeModule', ['getFilteredOutcomes']),
    ...mapGetters('authModule', ['hasPermission']),
    canUpdate () { return this.hasPermission('plant.outcomes.update') }
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  watch: {
    'getFilteredOutcomes': function () {
      this.outcomes = this.$store.getters['outcomeModule/getFilteredOutcomes']
    },
    'isRefreshTableRequired': function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    initialize () {
      this.$store.dispatch('outcomeModule/getOutcomes').then(() => {
        this.outcomes = this.$store.getters['outcomeModule/getOutcomes']
      })
    },

    formatLocalDate (value) {
      return formatDate(value)
    },

    getRawItem (item) {
      return item.raw || item
    },

    getNetWeight (item) {
      if (!item.grossWeight || !item.truckWeight) {
        return ''
      }
      return item.grossWeight - item.truckWeight
    },

    editItem (item) {
      const selected = Object.assign({}, item, { loadingDate: toLocalDateInput(item.loadingDate) })
      this.$store.dispatch('outcomeModule/setSelectedItem', selected)
      this.$store.dispatch('outcomeModule/setDialogActived', true)
    },

    showCommodity (item) {
      this.selectedOutcomeNumber = item.outcomeNumber
      this.selectedCommodities = Array.isArray(item.commodities)
        ? item.commodities
        : Object.values(item.commodities || {})
      this.commodityDialog = true
    }
  }
}
</script>
